import React from 'react';

/**
 * SAAWordmark — locked tri-color identity mark.
 *
 *   SCHOLAR (white) / ATHLETE (orange) / ACADEMY (dim gold)
 *
 * Modeled after the L'Chaim tri-color wordmark. Appears identically on
 * every page so the brand reads as one-of-one instead of another
 * black+orange-gradient AI-slop template.
 *
 * Sizes:
 *   'xs'    header nav (stacked 2-line micro caps)
 *   'sm'    footer / sub-brand mentions
 *   'md'    section headers
 *   'lg'    hero primary wordmark
 */
const COLOR_WHITE = '#FFFFFF';
const COLOR_ORANGE = '#FF5E00';
const COLOR_GOLD = '#C9A961';

const SIZES = {
  xs: 'text-[10px] leading-none',
  sm: 'text-sm',
  md: 'text-2xl md:text-3xl',
  lg: 'text-4xl md:text-6xl lg:text-7xl',
};

const SAAWordmark = ({ size = 'md', stacked = false, className = '', ...rest }) => {
  const sizeClass = SIZES[size] || SIZES.md;
  const tracking = size === 'xs' ? 'tracking-[0.28em]' : size === 'lg' ? 'tracking-tight' : 'tracking-[0.16em]';

  if (stacked) {
    // Two-line stacked variant for the header — keeps mark compact
    return (
      <div className={`flex flex-col leading-none ${className}`} data-testid="saa-wordmark" {...rest}>
        <span className={`${sizeClass} ${tracking} font-black uppercase`} style={{ color: COLOR_WHITE }}>
          Scholar<span style={{ color: COLOR_ORANGE }}> Athlete</span>
        </span>
        <span className={`${sizeClass} ${tracking} font-black uppercase mt-0.5`} style={{ color: COLOR_GOLD }}>
          Academy
        </span>
      </div>
    );
  }

  // Single-line — hero / landing wordmark
  return (
    <span
      className={`${sizeClass} ${tracking} font-black uppercase inline-flex flex-wrap items-baseline gap-x-[0.35em] ${className}`}
      data-testid="saa-wordmark"
      {...rest}
    >
      <span style={{ color: COLOR_WHITE }}>Scholar</span>
      <span style={{ color: COLOR_ORANGE }}>Athlete</span>
      <span style={{ color: COLOR_GOLD }}>Academy</span>
    </span>
  );
};

export default SAAWordmark;
